import AxiosJob from '@/services/api/job/axios_job'

export default {
  createUserACL: (data) => AxiosJob.post('user-acl', data),
  updateUserACL: (userAclId, data) => AxiosJob.put(`user-acl/${userAclId}`, data),
  getUserACL: (userAclId) => AxiosJob.get(`user-acl/${userAclId}`),
  deleteUserACL: (userAclId) => AxiosJob.delete(`user-acl/${userAclId}`),
  getAllUserAcls: (params) => AxiosJob.get('user-acl', { params }),
  getUserAclsByUser: () => AxiosJob.get('user-acl/user'),
}
